import React from 'react';
import FeatherIcon from 'feather-icons-react';

function Icon(props) {
	const { icon, size, className, innerRef, ...rest } = props;
	return <div ref={innerRef}><FeatherIcon {...props} {...rest} icon={icon} size={size} color="inherit" className={className} /></div>	;
}

export default Icon;